<div class="content-wrapper">
    <div class="content-body">
        <section id="stockists">
            <div class="row">
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <h2 class="mt-5px">Car Fund Bonus</h2>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="filterForm">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="session_id">
                                        <option [value]="session.id" *ngFor="let session of sessions">
                                            {{session?.name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row search-card mt-1 mb-5px">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="transaction_id"
                                           placeholder="Transaction No.">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="member_name"
                                           placeholder="Downline Name">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="chargable_basic_total"
                                           placeholder="Commission">
                                </fieldset>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                                <fieldset class="form-group">
                                    <input class="form-control" type="date" formControlName="start_date_time">
                                    <small>Start Date</small>
                                </fieldset>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                                <fieldset class="form-group">
                                    <input class="form-control" type="date" formControlName="end_date_time">
                                    <small>End Date</small>
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Transaction No.</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Direct Downline Member Id</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Direct Downline Member</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Commission (In &#8377;)</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Date Time</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="carFundBonus && carFundBonus.length > 0; else noDataToShow">
                                        <tr *ngFor="let carFund of carFundBonus; let i = index">
                                            <td class="text-center">
                                                <h6>{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                    .</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6>{{carFund?.transaction_id}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6>{{carFund?.member?.member_id}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6>{{carFund?.member?.name}} ({{carFund?.member?.username}})</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6>{{carFund?.chargable_basic_total | number:'1.2-2'}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6>{{carFund?.transaction_date_time}}</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShow>
                                            <tbody>
                                            <tr>
                                                <td colspan="7" class="text-center">
                                                    No data to show
                                                </td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
